import { render, staticRenderFns } from "./WorkpieceManage.vue?vue&type=template&id=239aca88&scoped=true&"
import script from "./WorkpieceManage.vue?vue&type=script&lang=js&"
export * from "./WorkpieceManage.vue?vue&type=script&lang=js&"
import style0 from "./WorkpieceManage.vue?vue&type=style&index=0&id=239aca88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239aca88",
  null
  
)

export default component.exports